module.exports = __webpack_public_path__ + "img/pro-m-slider5.9a8ffa7f.png";